import api from './api';

export const getStats   = (params) => api.get('/api/community-data/stats',   { params });
export const getSummary = (params) => api.get('/api/community-data/summary', { params });

export const getExports   = (params) => api.get('/api/community-data/exports',      { params });
export const getExport    = (id)     => api.get(`/api/community-data/exports/${id}`);
export const createExport = (data)   => api.post('/api/community-data/exports', data);

export const getMyConsent    = (params) => api.get('/api/community-data/consent', { params });
export const updateMyConsent = (data)   => api.put('/api/community-data/consent', data);
